import SelectDuplicateContactsStep from './select-duplicate-contacts-step.vue';
import CompareContactsStep from './compare-contacts-step.vue';
import MergeContactsStep from './merge-contacts-step.vue';
import MergeCompleteStep from './merge-complete-step.vue';
import ContactList from './ContactList.vue';
import DuplicatesManager from './DuplicatesManager.vue';

export default {
  ContactList,
  DuplicatesManager,
  SelectDuplicateContactsStep,
  CompareContactsStep,
  MergeContactsStep,
  MergeCompleteStep,
};
